import { useCallback, useEffect, useRef, useState } from 'react';
import { ToastState } from '../types';

export interface ToastHookState {
  toast: ToastState;
  showToast: (msg: string) => void;
}

const initialState: ToastState = { visible: false, message: '' };

export const useToast = (): ToastHookState => {
  const [toast, setToast] = useState<ToastState>(initialState);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(
    () => () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    },
    [],
  );

  const showToast = useCallback((msg: string): void => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    setToast({ visible: true, message: msg });
    timeoutRef.current = setTimeout(() => {
      setToast(prev => ({ ...prev, visible: false }));
    }, 2400);
  }, []);

  return { toast, showToast };
};
